module.exports = __webpack_public_path__ + "static/media/IMG_20191204_125722.4806fd46.jpg";